import { extend } from "vee-validate";
import {
    required,
    min,
    max,
    between,
    email,
    confirmed
} from "vee-validate/dist/rules";
import password from "./rules/password";

export function configureValidation() {
    extend("required", required);
    extend("min", min);
    extend("max", max);
    extend("between", between);
    extend("email", email);
    extend("confirmed", confirmed);

    // custom validators
    extend("password", password);

    // dummy validators for property info
    extend("displayName", { validate: () => true });
    extend("propertyName", { validate: () => true });
}

interface IValidator extends Vue {
    validate(): Promise<boolean>;
}

export { IValidator };
